// @ts-nocheck
import React, { useState } from 'react'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import * as PropTypes from 'prop-types'
import { noop } from 'lodash'

const propTypes = {
  panelId: PropTypes.number,
  summaryContent: PropTypes.string,
  handleClick: PropTypes.func,
  isOpen: PropTypes.func,
}

const defaultProps = {
  panelId: NaN,
  summaryContent: '',
  handleClick: noop,
  isOpen: noop,
}

const MaterialUIWrapperSelectableAccordion = ({
  panelId,
  summaryContent,
  handleClick,
  isOpen,
  children,
  isDisabled,
}) => {
  const [open, setOpen] = useState(isOpen)
  const handleChange = () => {
    setOpen(!open)
    handleClick()
  }

  return (
    <MuiAccordion
      square
      expanded={open}
      onChange={handleChange}
      className="material-ui-wrapper--accordion material-ui-wrapper--selectable-accordion"
      disabled={isDisabled}
    >
      <MuiAccordionSummary
        aria-controls={`panel-${panelId}-content`}
        id={`panel-${panelId}-header`}
        className="material-ui-wrapper--accordion-summary material-ui-wrapper--selectable-accordion-summary"
      >
        {summaryContent}
      </MuiAccordionSummary>
      <MuiAccordionDetails className="material-ui-wrapper--accordion-details material-ui-wrapper--selectable-accordion-details">
        {children}
      </MuiAccordionDetails>
    </MuiAccordion>
  )
}

MaterialUIWrapperSelectableAccordion.propTypes = propTypes
MaterialUIWrapperSelectableAccordion.defaultProps = defaultProps

export default MaterialUIWrapperSelectableAccordion
